diy.angular.registerDirective('diyfmblockingmask', [ 
function() {
    var $ = jQuery;
    return {
        restrict: 'A',
        link: function(scope, elem, attr) {

            var $elem = $(elem), mask;
            
            var getConfig = function() {
                return scope.$eval(attr.diyfmblockingmask);
            }
            
            var config = getConfig();
            if (config === undefined) {
                var unWatch = scope.$watch(getConfig, function(val){
                    config = val;
                    unWatch();
                })
            }
            
            scope.$watch(config.isBlocked, function(isBlocked, oldIsBlocked){
                if (isBlocked !== oldIsBlocked) {
                    if (isBlocked) {
                        if ($elem.css('position') === 'static') {
                            $elem.css('position', 'relative');
                        }
                        mask = $('<div class="fm-blocking-mask"></div>').appendTo($elem);
                        if (config.getReasons().length > 0) {
                            mask.diy_simpleTooltip({
                                content: config.getReasons().join('<br/>'),
                                trackMouse: true,
                                triggerMode: 'click',
                                anchorToTarget: false
                            });
                        }
                    } else {
                        mask.remove();
                        $elem.css('position', '');
                    }
                }
            });
            
            scope.$on('$destroy', function(){
                // cleanup to prevent memory leaks
                config = null;
                attr = null;
                mask && mask.remove();
                mask = null;
            });
        }
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmblockingmask.js
 ** module id = 981
 ** module chunks = 0
 **/